import React, { memo } from 'react';
import MeetingLayout from './MeetingLayout';

const TutorMeeting = ({ attendees, tutorStream, handleAddTutorAudio, handleAddTutorCam, meetingStarted }) => (
    <MeetingLayout
        attendees={attendees}
        tutorStream={tutorStream}
        meetingStarted={meetingStarted}
        audience="teacher"
        handleTutorAudio={handleAddTutorAudio}
        handleTutorCam={handleAddTutorCam}
    />
);

export default memo(TutorMeeting);
